import {TABLE_VIEW_DEFAULT} from '../constants';

export const getValue = (
  key: string,
  defaultValue: string | null | undefined = null,
) => {
  let value: string | null | undefined = defaultValue;
  try {
    value = localStorage.getItem(key) || defaultValue;
  } catch {
    // Ignore errors
  }
  return value;
};

export const setValue = (key: string, value: string) => {
  let success = true;
  try {
    localStorage.setItem(key, value);
  } catch {
    success = false;
  }
  return success;
};

export const deleteItem = (key: string) => {
  let success = true;
  try {
    localStorage.removeItem(key);
  } catch {
    success = false;
  }
  return success;
};

export const clearItem = (key: string) => {
  let success = true;
  try {
    const emptyItem = [];
    setValue(key, JSON.stringify(emptyItem));
  } catch {
    success = false;
  }
  return success;
};

export const setVisibleColumns = (columns: Record<string, boolean>) => {
  return setValue('visibleColumns', JSON.stringify(columns));
};

export const getVisibleColumns = () => {
  let columns: Record<string, boolean> = TABLE_VIEW_DEFAULT;
  try {
    const storedColumns = getValue('visibleColumns');
    if (storedColumns) {
      const newColumns = JSON.parse(storedColumns);
      let allKeysPresent = true;
      Object.keys(TABLE_VIEW_DEFAULT).forEach(key => {
        if (!(key in newColumns)) {
          allKeysPresent = false;
        }
      });
      if (allKeysPresent) {
        columns = newColumns;
      }
    }
  } catch {
    // Ignore errors
  }
  return columns;
};
